import React, { useState } from "react";
import { Box, Text, Heading } from "rebass";
import { buttonStyle, maxWidth, height } from "styled-system";
import styled from "styled-components";
import SVG from "react-inlinesvg";
import { COPY, SOCIAL } from "./content";
import { NewsletterOverlay } from "./newsletter-overlay";
import { useRouter } from "next/router";

const Newsletter = ({ withSocial }) => {
  const router = useRouter();

  const [overlayStatus, setOverlayStatus] = useState(router.query.subscribe);

  const toggleOverlay = () => {
    const { subscribe, ...otherQueries } = router.query;
    const query = overlayStatus
      ? otherQueries
      : { ...otherQueries, subscribe: true };

    router.replace({
      pathname: router.route === "/index" ? "/" : router.route,
      query: query
    });

    setOverlayStatus(!overlayStatus);
  };

  return (
    <Box py={[4, 4, 4, 6]} px={[3, 3, 3, 4]}>
      {overlayStatus && <NewsletterOverlay close={() => toggleOverlay()} />}
      <Inner maxWidth={1} mx="auto" textAlign="center">
        <Title
          lineHeight={1}
          as="h2"
          fontFamily="medium"
          letterSpacing={1}
          fontSize={[4, 4, 5, 6]}
        >
          {COPY.title}
        </Title>
        <Box mt={[4, 4, 5]}>
          <FormButton
            as="button"
            variant="yellow"
            py={3}
            px={5}
            textAlign="center"
            fontFamily="medium"
            fontSize={1}
            letterSpacing={0.12}
            onClick={() => {
              toggleOverlay();
            }}
          >
            Subscribe
          </FormButton>
        </Box>
        {COPY.social && withSocial && (
          <Text textAlign="center" mt={[4, 4, 5]}>
            {SOCIAL.map((platform, i) => (
              <SocialIcon
                key={i}
                as="a"
                ml={i > 0 ? 45 : 0}
                href={platform.url}
                target="_blank"
                width={platform.width}
                height={platform.height}
              >
                <SVG src={platform.icon} />
              </SocialIcon>
            ))}
          </Text>
        )}
      </Inner>
    </Box>
  );
};

const FormButton = styled(Text)`
  ${buttonStyle};
  border: none;
  cursor: pointer;
`;

const SocialIcon = styled(Box)`
  ${height}
  display: inline-block;

  a,
  svg {
    display: block;
  }

  svg {
    width: 100%;
    height: 100%;
    fill: white;
  }
`;

const Inner = styled(Text)`
  ${maxWidth}
`;

const Title = styled(Heading)`
  text-transform: uppercase;
`;

export { Newsletter };
